import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';

export const ControlledNestedRouteWords = () => {
  const data = [
    FindLangKey('complete-user-information-navbar-title'),
    FindLangKey('general-public-about-us'),
    FindLangKey('upload-oncall-documents-navbar-title'),
    FindLangKey('general-public-contact-us'),
    FindLangKey('bank-account-list-navbar-title'),
    FindLangKey('general-public-change-password'),
    FindLangKey('messages-navbar-title'),
    FindLangKey('main-menu-button-pacs-images'),
    FindLangKey('main-menu-button-pacs-images'),
    FindLangKey('user-survey-route-title'),
    FindLangKey('user-pishnahad-route-title'),
    FindLangKey('patients-for-visit-navbar-title'),
  ];
  return data;
};
